import styled, { css } from 'styled-components';
import { Modal } from 'antd';
import { ScrollableWrapper } from '../ui-helpers/scrollable-wrapper';

export const Title = styled.div`
  text-align: center;
  font-size: 24px;
  font-weight: normal;
  color: ${props => props.theme.colors.fontSilverDark};
  margin-bottom: 30px;  
`;

export const ModalS = styled(Modal)` 
  ${({ isCloseIconOuter }) => isCloseIconOuter && css`
    .ant-modal-body {
      margin-top: 24px;
    }
    .ant-modal-close {
      top: -35px;
      right: -35px;
      color: ${({ theme }) => theme.colors.white};
      
      &:hover {
        opacity: .8;
      }
    }
  `};
`;

export const ScrollableWrapperS = styled(ScrollableWrapper)`
  padding: 0;
  overflow: inherit;
  height: max-content;
`;



// WEBPACK FOOTER //
// ./src/components/modal/styled-components.js